'use strict';
module.exports = require('./Panel.vue');